/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   Butter Bar Singleton
 */

import ButterBarManager from './butter_bar'

export default new ButterBarManager()
